module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-144x144-29bfb662aa99ad482e902e092706e044.png";